exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border{border:1px solid #b3b3b3;padding:.5rem;margin-bottom:1rem;min-height:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/management/queues/queues.component.css
// module id = 245
// module chunks = 0